<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    银湖站<br>
站点介绍<br>
银湖站位于北环大道银湖汽车站南侧，沿北环大道呈东西方西布置，南接笔架山公园，西接孖岭站，东接泥岗站，车站装修以白色为基准色，墙柱用黄色陶瓷钢板装饰，天花由白色铝合金吊挂横向挂置而成，整体效果简介大方。车站共设置4个出入口，其中A、C出入口为预留出入口。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:20	00:03	6号线	3分24秒	6分20秒<br>
松岗	06:27	23:07	6号线	3分24秒	6分20秒<br>
前湾	06:37	23:17	9号线	3分50秒	5分55秒<br>
文锦	06:10	23:51	9号线	3分50秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:19	00:03	6号线	4分45秒	6分钟<br>
松岗	06:27	23:07	6号线	4分45秒	6分钟<br>
前湾	06:37	23:17	9号线	4分25秒	5分55秒<br>
文锦	06:09	23:51	9号线	4分25秒	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:19	01:03	6号线	4分45秒	6分钟<br>
松岗	06:27	00:07	6号线	4分45秒	6分钟<br>
前湾	06:37	00:17	9号线	4分钟	5分55秒<br>
文锦	06:06	00:51	9号线	4分钟	5分55秒<br><br>
<br>
站点出口信息<br><br>
B出入口:<br>
北环大道北侧（东）、金碧路、金湖大厦、四季青花园、深圳市花卉协会、信城·缙山府<br><br>
D出入口:<br>
北环大道北侧（西）、银湖汽车站、金碧苑、金湖山庄、深圳画院、博宁现代国学院<br>
公交换乘信息<br><br>
D出入口:<br>
公交站名： 银湖汽车站①<br>
46路，高峰专线19路,201路，E24路,M240路，M240路大站快车，M358路,M437路,M526路， N6路,4路，5路，5路越站快车，218路，236路，M152路,M454路，D出入口<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "liuhaoxian",
          title: "6号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "jiuhaoxian",
          title: "9号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>